import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/GoogleLoginComponent.css';
import { authAPI } from '../api/apiClient';
import useApi from './CustomHooks/useApi';
import LoadingOverlay from '../LoadingOverlay';

const GoogleLoginComponent = ({ setUser }) => {
  const navigate = useNavigate();
  const { callApi, isLoading } = useApi();
  useEffect(() => {
    window.google.accounts.id.initialize({
      client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
      callback: handleCredentialResponse,
      auto_select: false,
    });
    window.google.accounts.id.renderButton(
      document.getElementById('googleSignInDiv'),
      {
        theme: 'outline',
        size: 'large',
        text: 'signin_with',
        shape: 'pill',
      }
    );
  }, []);

  const handleCredentialResponse = async (response) => {
    try {
      const res = await callApi(() => authAPI.googleLogin(response.credential));
      setUser(res.user); 
      navigate('/');
    } catch {
    }
  };

  return (
    <div className={`google-login-wrapper ${process.env.REACT_APP_ENV === 'test' ? 'test-env' : ''}`}>
      {isLoading && <LoadingOverlay text="Logowanie..." />}
      <div className="google-login-card">
        <h1 className="google-login-title">Witaj!</h1>
        <p className="google-login-subtitle">
            Zaloguj się, aby kontynuować
            {process.env.REACT_APP_ENV === 'test' && (
              <span className="env-label-inline"> – ŚRODOWISKO TESTOWE</span>
            )}
          </p>
        <div id="googleSignInDiv" className="google-signin-button"></div>
      </div>
    </div>
  );
};

export default GoogleLoginComponent;
